import React, { Fragment, memo, useState } from 'react';
import Botones from '../../../components/UI/botonera/headerBotones.js';
import CajaTexto from '../../../components/UI/cajaTexto/cajaTexto.jsx';
import ComboBox from '../../../components/UI/comboBox/combobox.jsx';
import ComboBoxMulti from '../../../components/UI/comboBox/comboboxmulti.jsx';
export function mantCatalogoCentroCostoInt(props) {
    return (
        <Fragment>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.Titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <div className='row'>
                            <div className='row'>
                                <CajaTexto col="6" id="CentroCosto" type="text" label={props.Datos.CentroCosto.attributes.label} value={props.Datos.CentroCosto.value} attributes={props.Datos.CentroCosto.attributes} onChangeInput={props.onChangeInput} />
                                <CajaTexto col="6" id="Nombre" type="text" label={props.Datos.Nombre.attributes.label} value={props.Datos.Nombre.value} attributes={props.Datos.Nombre.attributes} onChangeInput={props.onChangeInput} />
                            </div>
                            <div className='row'>
                                <ComboBox id="cmbEstado" col="6" attributes={props.Datos.Estado.attributes} value={props.selectedOptionEstado} label={props.Datos.Estado.attributes.label} datos={props.listaEstado} onChange={props.onhandleSelectedEstado} />
                            </div>
                            <div className='row'>
                                <ComboBoxMulti id="selectedEmpresas" col="6" attributes={props.Datos.Empresas.attributes} value={props.selectedEmpresas} label={props.Datos.Empresas.attributes.label} datos={props.listaEmpresas} onChange={props.onhandleSelectEmpresas} placeholder={"Seleccione"} />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};
export default memo(mantCatalogoCentroCostoInt);